module.exports = __webpack_public_path__ + "img/twelve-thirty.be6a58c2.png";